import useTransferListStore from '@aibees/shared/features/transfer-list/store/transfer-list-store';
import { useCallback } from 'react';

export function useClearTransferList() {
  const { config, setIncluded, setExcluded } = useTransferListStore();

  return useCallback(() => {
    const excludedDraft = config?.items
      ?.filter((x) => !x.disable)
      .map((x) => x.id);
    const includedDraft = config?.items
      ?.filter((x) => x.disable)
      .map((x) => x.id);
    setIncluded(includedDraft);
    setExcluded(excludedDraft);
  }, [config, setIncluded, setExcluded]);
}
